import React from 'react';

export const PersonIcon = ({ className }) => {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<circle cx="12" cy="6" r="5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
			<path fillRule="evenodd" clipRule="evenodd" d="M11.9994 16C16.3143 16 20 16.6983 20 19.4875C20 22.278 16.3376 23 11.9994 23C7.68457 23 4 22.303 4 19.5125C4 16.722 7.66119 16 11.9994 16Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
			<path fillRule="evenodd" clipRule="evenodd" d="M11.9994 11C9.22374 11 7 8.77512 7 5.99943C7 3.22488 9.22374 1 11.9994 1C14.7751 1 17 3.22488 17 5.99943C17 8.77512 14.7751 11 11.9994 11Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
		</svg>
	);
};
